import classnames from 'classnames';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';

import {
	LegacyGrid as Grid,
	LegacyGridCol as GridCol,
	Dropdown,
	DropdownItem,
	Header,
	HeaderBrand,
	HeaderNavigation,
	HeaderWidgets,
	NavItem,
	Switch,
	ToggleButton,
} from '@flixbus/honeycomb-react';

import FeedbackBanner from 'common/FeedbackBanner';
import { useFlixTheme } from 'contexts/ThemeContext';

import { CURRENTLY_DEPLOYED_BRANCH, DARK_MODE_LABEL } from './const';
import { getEnvClass } from './helpers';
import useAppHeader from './hooks/useAppHeader';
import { HEADER_TEXT } from './text';

import styles from './styles.module.css';

const AppHeader = observer(() => {
	const { isUserLoggedIn, userAccountName, visibleMenuItems, paths, handleAuthAction, branchName } =
		useAppHeader();
	const { toggleTheme, isDark } = useFlixTheme();
	const envClass = getEnvClass();
	const [userMenuExpanded, setUserMenuExpanded] = useState(false);

	const handleThemeToggle = () => {
		toggleTheme();
	};

	const userMenuLinks = [
		isUserLoggedIn && (
			<DropdownItem key="profile" href="/profile">
				{HEADER_TEXT.userProfile.profile}
			</DropdownItem>
		),
		<DropdownItem key="auth" Elem="button" onClick={handleAuthAction}>
			{isUserLoggedIn ? HEADER_TEXT.userProfile.logoutButton : HEADER_TEXT.userProfile.loginButton}
		</DropdownItem>,
		branchName && (
			<DropdownItem key="branch">
				{CURRENTLY_DEPLOYED_BRANCH}
				<br />
				{branchName}
			</DropdownItem>
		),
	].filter(Boolean);

	const headerClasses = classnames(styles.marginHeader, envClass);

	return (
		<>
			<FeedbackBanner />
			<Header
				extraClasses={headerClasses}
				fixed
				fullwidth
				widgetSize="l"
				navigation={
					<HeaderNavigation aria-label="Main navigation">
						{visibleMenuItems.map(({ uuid, link, prefix, title }) => (
							<NavItem key={uuid} href={link} active={paths[1] === prefix}>
								{title}
							</NavItem>
						))}
					</HeaderNavigation>
				}
				brand={
					<HeaderBrand
						href="/"
						src="https://honeycomb-assets.hive.flixbus.com/honeycomb-logos-static/2.0.0/svg/flix-white.svg"
						alt="Flix Dispatch"
						width="70"
						height="24"
						extraClasses={styles.brand}
					/>
				}
				widgets={
					<HeaderWidgets>
						<Grid align="center">
							<GridCol extraClasses={styles.themeSwitcher}>
								<Switch
									id="theme-switcher-header"
									extraClasses="theme-switcher"
									small
									label={DARK_MODE_LABEL}
									checked={isDark}
									onChange={handleThemeToggle}
								/>
							</GridCol>
							<GridCol extraClasses={styles.userWidget}>
								<nav aria-label="User menu">
									<Dropdown xPosition="left" links={userMenuLinks} onToggle={setUserMenuExpanded}>
										<ToggleButton
											noWrap
											iconSize="M"
											appearance="link"
											aria-expanded={userMenuExpanded}
										>
											{userAccountName}
										</ToggleButton>
									</Dropdown>
								</nav>
							</GridCol>
						</Grid>
					</HeaderWidgets>
				}
			/>
		</>
	);
});

export default AppHeader;
